import { type FC, useState } from "react";
import { ButtonLink } from "@stubhub/broadway-web";
import { CloseIcon, TicketsOutlineIcon } from "@stubhub/broadway-web/icons/functional";
import { useContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { signInBannerRecipe } from "src/website-apps/responsive/stubhub-performer/components/performer-sign-in-banner/styled-components";

const bannerStyles = signInBannerRecipe();

interface Props {
  profileUrl: string;
}

export const SignInBanner: FC<Props> = ({ profileUrl }) => {
  const storePageEvent = useStorePageEvent();
  const [showBanner, setShowBanner] = useState(true);
  const mainCtaButton = useContent("cid$#3323320#"); // "Sign in / Create an account"
  const betterTicketRecommendationContent = useContent("cid$#3323359#"); // "Want better ticket recommendations?"

  return showBanner ? (
    <div className={bannerStyles.container}>
      <div className={bannerStyles.body}>
        <span className={bannerStyles.icon}>
          <TicketsOutlineIcon size={32} />
        </span>
        <div className={bannerStyles.flexContent}>
          <div className={bannerStyles.text}>
            <div className={bannerStyles.heading}>{betterTicketRecommendationContent}</div>
          </div>
          <div className={bannerStyles.divider} />
          <div className={bannerStyles.cta}>
            <div className={bannerStyles.buttonWrap}>
              <ButtonLink
                href={profileUrl}
                onClick={() => {
                  storePageEvent(PE_TYPE.CLICK, PE_KEYS.PERFORMER_SIGN_IN_BANNER_CTA, "");
                }}
              >
                {mainCtaButton}
              </ButtonLink>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button
          type="button"
          aria-label="Close"
          className={bannerStyles.close}
          onClick={() => {
            setShowBanner(false);
            storePageEvent(PE_TYPE.CLICK, PE_KEYS.PERFORMER_SIGN_IN_BANNER_CLOSE, "");
          }}
        >
          <CloseIcon size={20} />
        </button>
      </div>
    </div>
  ) : null;
};
